// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"96":"Signin","187":"NotFound","362":"Dashboard","584":"DashboardDetail","850":"Addon"}[chunkId] || chunkId) + "." + {"96":"4524d8b9","187":"1d1cb416","245":"df90bc99","304":"0542a493","362":"de030fcf","584":"ccca8d85","850":"84530a06"}[chunkId] + ".js";
};